import React from 'react';

interface ExternalLinkProps {
  children: React.ReactNode;
  href: string;
  className?: string;
  title?: string;
  rel?: {
    noOpener?: boolean;
    noReferrer?: boolean;
  };
}

// External link that opens in a new tab/window, ensuring that the
// opened page doesn't have access to the current page.
const ExternalLink: React.FC<ExternalLinkProps> = ({
  children,
  href,
  className,
  title,
  rel = { noOpener: true, noReferrer: true },
}) => (
  /* eslint-disable-next-line react/jsx-no-target-blank */
  <a
    href={href}
    target="_blank"
    rel={[rel.noOpener && 'noopener', rel.noReferrer && 'noreferrer'].filter(Boolean).join(' ')}
    className={className}
    title={title}
  >
    {children}
  </a>
);

export default ExternalLink;
